export var findOrCreateElementAndInject = function (id) {
    var findElement = document.getElementById(id);
    if (findElement)
        return findElement;
    var element = document.createElement('div');
    element.setAttribute('id', id);
    document.body.appendChild(element);
    return element;
};
